
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass, Style } from '../../style';

export namespace DraftStyles {
    const cssPrefix = 'Draft';

    export const DraftTagsCardContainer = cssClass(cssPrefix, '-tag-container', {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: CommonStyles.Sizes.MediumSpace,
    });

    export const DraftTagStyle = cssClass(cssPrefix, '-tag', {
        marginRight: '8px',
    });
    export const ListViewContainer = cssClass(cssPrefix, '-list-tag-container', {
        marginLeft: CommonStyles.Sizes.DefaultSpace,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingRight: '8px',
    });

    export const DraftTagNoLeftMargin = cssClass(cssPrefix, '-tag-no-left-margin', {
        marginLeft: 0
    });
}

export namespace TooltipDraftIndicatorStyles {
    const cssPrefix = 'TooltipDraftIndicator';

    export const ContainerStyle = cssClass(cssPrefix, '-container', {
        display: 'flex',
        paddingRight: '8px',
        alignItems: 'baseline',
    });

    export const TextStyle = cssClass(cssPrefix, '-text', {
        display: 'inline',
        fontSize: CommonStyles.Sizes.NormalFontSize.toString() + 'px',
        letterSpacing: '0.2px',
        lineHeight: '1.5',
    });

    export const IconStyle = cssClass(cssPrefix, '-icon', {
        marginRight: '4px', verticalAlign: 'top',
    });

    export const buttonHoverStyle: Style = {
        $nest: {
            '&:hover:enabled': {
                textDecoration: 'underline',
                cursor: 'pointer',
                backgroundColor: 'transparent',
                color: CommonStyles.Colors.HyperlinkBlueHover
            },
        },
    };

    export const InlineButtonStyles: React.CSSProperties = {
        padding: 0,
        color: CommonStyles.Colors.HyperlinkBlue
    };
}
